<template>
  <div class="root_phone flex-col scaler_phone">
    <div class="block_1 flex-row">
      <div class="group_1 flex-col">
        <div class="image-wrapper_1 flex-row" style="cursor: pointer;">
          <router-link to="/store/dashboard/profile">
            <img class="label_1" style="height:29px;" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG2782f6d9ac2f655cfbb22e2b6cc09020.png" />
          </router-link>
        </div>
        <div class="section_1 flex-row justify-center" style="height:60px;">
          <span style="font-size: x-large;font-weight: 700;">换绑微信号</span>
        </div>
        <div class="section_2 flex-row">
          <el-form>
            <!-- label-position需与label-width一起使用才生效 -->
            <el-form-item prop="oldPhone" label="原手机号" label-position="left" label-width="80px">
              <el-input v-model="oldPhone" placeholder="请输入原手机号">
                <template #append>
                  <div class="append_button" @click="sendSmsCode('old')">&nbsp;&nbsp;发送验证码&nbsp;&nbsp;</div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="oldEmail" label="验证码" label-position="left" label-width="80px">
              <el-input v-model="oldSms" placeholder="请输入验证码"></el-input>
            </el-form-item>
            <el-form-item prop="newPhone" label="新手机号" label-position="left" label-width="80px">
              <el-input v-model="newPhone" placeholder="请输入新手机号">
                <template #append>
                  <div class="append_button" @click="sendSmsCode('new')">&nbsp;&nbsp;发送验证码&nbsp;&nbsp;</div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="newEmail" label="验证码" label-position="left" label-width="80px">
              <el-input v-model="newSms" placeholder="请输入验证码"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="section_3 flex-row justify-between" style="margin-top:200px;">
          <div class="text-wrapper_3 flex-col"><span class="text_9">&nbsp;确认</span></div>
          <div class="text-wrapper_4 flex-col"><span class="text_10">取消</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  
  data() {
    return {
      editUsrname: false,
      oldPhone: '',
      oldSms: '',
      newPhone: '',
      newSms: '',
    };
  },
  methods: {
    async sendSmsCode(mode){
      if(mode == 'old'){
        let res = await this.$store.dispatch('sms/sendSmsCode', { mobile: parseInt(this.oldPhone), scene: 'YZMDL' })
      }else if(mode == 'new'){
        
        if(this.newPhone == this.oldPhone){
          this.$message({
            message: '新手机号不能与原手机号相同',
            type: 'error'
          });
          return;
        }
        let res = await this.$store.dispatch('sms/sendSmsCode', { mobile: parseInt(this.newPhone), scene: 'YZMDL' })
      }

      if(res.data.code == 1){
        this.$message({
          message: '发送成功',
          type: 'success'
        });
      }else{
        this.$message({
          message: res.data.msg,
          type: 'error'
        });

      }
    },


  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.scaler_phone {
  transform-origin: top left;
  transform: scale(0.75);
}

::v-deep .el-input__inner {
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid;
  border-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%) 1;
}

::v-deep .el-input__inner::placeholder {
  color: gray; 
  opacity: 1; 
}

::v-deep .el-input-group__append {
  background-color: transparent;
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 110, 249, 1);
  padding: 0px;
}

.append_button {
  height:30px;
  background-color:white;
  line-height:30px;
  border-radius:15px;
  font-size:x-small;
  border: 1px rgba(177, 110, 249, 1) solid;
  color: rgba(100,100,100,1);
  cursor: pointer;
}
</style>